import React, { Component } from 'react';
import kwootLogoYellow from '../kwoot/logo-yellow.svg';
import kwootLogoBlack from '../kwoot/logo-black.svg';
import './sidebartop.css';
import Link from 'react-router-dom/Link';
import Menu from '../menu/menu';
import Menutoggler from '../menutoggler/menutoggler';
import Button from '../button/button';
import ReactFitText from 'react-fittext';
import VideoCover from 'react-video-cover';


import has from 'lodash.has';
import get from 'lodash.get';

class Sidebartop extends Component {

    constructor(props) {
        super(props);

        this.renderGroupButton = this.renderGroupButton.bind(this);
    }

    render() {

        const menuWhite = get(this, 'props.menuwhite', true);
        this.hasVideo = (has(this, 'props.video') && false !== this.props.video && null !== this.props.video);

        let videoElement = '';

        if (this.hasVideo) {
            //use temporary first video
            let video = this.props.video[0];

            videoElement = (
                <VideoCover videoOptions={{src: video.sidebar_movie_src, autoplay: "", loop: "loop", playsinline: "", ref:(videoElement) => { this.videoElement = videoElement; } }} key={this.props.id} className="sidebar__video"/>
            );
        }

        let kwootLogo = (<Link to="/" className="home"><img className="sidebar__kwootLogoYellow" src={kwootLogoYellow} alt="Kwoot logo"/></Link>);
        if (has(this,'props.logoblack')) {
            kwootLogo = (<Link to="/" className="home"><img className="sidebar__kwootLogoBlack" src={kwootLogoBlack} alt="Kwoot logo"/></Link>);
        }

        return (
            <div className="sidebar__top" style={{backgroundImage: `url('${this.props.image}')`}}>
                <Menu/>
                <div className="sidebar__content">
                    <div className="sidebar__topnav">
                        <Menutoggler menuwhite={menuWhite}/>
                        { this.renderGroupButton() }
                    </div>
                    <ReactFitText maxFontSize={34}><h1 className="sidebar__title" dangerouslySetInnerHTML={{__html: this.props.title}} /></ReactFitText>
                    { has(this,'props.supertitle' ) ? <h2 className="sidebar__supertitle">{get(this,'props.supertitle')}</h2> : '' }
                    { has(this,'props.date' ) ? <p className="sidebar__date">{get(this,'props.date')}</p> : '' }

                    {kwootLogo}
                </div>
                {videoElement}
            </div>
        );
    }

    renderGroupButton() {
        if (has(this, 'props.groupbuttontitle') && has(this, 'props.groupbuttonlink')) {
            return (
                <Button name={get(this, 'props.groupbuttontitle')} href={get(this, 'props.groupbuttonlink')} color="transparent" bordercolor="white" textcolor="white" grid={true}/>
            );
        }
    }

    componentWillUnmount() {
        if (this.hasVideo) {
            this.videoElement.src = '';
            this.videoElement.load();
        }
    }
}

export default Sidebartop;



// WEBPACK FOOTER //
// ./src/components/sidebartop/sidebartop.js